import { deliveryNotes } from './delivery-notes-en.i18n';

export const en = {
  deliveryNotes,
};
